import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/79_card_back_halloween_castle/79_card_back_halloween_castle"
 * Contains 1 texture(s)
 */
export class CardsBacks79CardBackHalloweenCastleAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/79_card_back_halloween_castle/79_card_back_halloween_castle';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '79_halloween_castle.png'
    ] as const;
}
